import myShopClient from '@services/nearlive';

import { useShop } from '@/hooks/useShop';
import { useBillingStatus } from '@/hooks/useBillingStatus';

/**
 * Drives the Unify Close-account flow (NEA-6014).
 *
 * `cancel()` POSTs to `/api/billing/subscription/{shopId}/cancel`. The server
 * branches on the org's billable-shop count and reports which journey ran via
 * `mode` in the response:
 *
 *   - `'account'` — cancel_at_period_end set on the org's Unify sub (single
 *     location, or the chain's last active store). Loops Email 23 fires.
 *   - `'location'` — only this store leaves the chain's shared sub: billing
 *     reduced immediately (paid through period end, no credit), `closeAt`
 *     written on the shop row, executed at period end by unify-billing.
 *
 * On success we `mutate()` the billing-status cache (cancellation banner) AND
 * the shops cache (`closeAt` rides `/api/my-shop`) so the page reflects the
 * new state without waiting for a refocus.
 */
export function useCancelSubscription() {
	const { shop, mutate: mutateShops } = useShop();
	const { mutate } = useBillingStatus(shop?.id);

	const cancel = async () => {
		if (!shop?.id) throw new Error('No shop available to cancel');
		const client = await myShopClient();
		const { data } = await client.post(`/api/billing/subscription/${shop.id}/cancel`);
		await Promise.all([mutate(), mutateShops()]);
		return data;
	};

	return { cancel };
}
